<template>
  <div class="">
    <NavEL></NavEL>
    <PublicLanding></PublicLanding>
  </div>
</template>

<script>
export default {
  components: {
    ...require('../kit.js').default
  }
}
</script>

<style>

</style>
